import { render, staticRenderFns } from "./prd_in_two.vue?vue&type=template&id=341b670a&scoped=true&"
import script from "./prd_in_two.vue?vue&type=script&lang=js&"
export * from "./prd_in_two.vue?vue&type=script&lang=js&"
import style0 from "./prd_in_two.vue?vue&type=style&index=0&id=341b670a&scoped=true&lang=less&"
import style1 from "./prd_in_two.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341b670a",
  null
  
)

export default component.exports